import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  palette,
  fontSizes,
  fontWeights,
}: Theme) => ({
  veevaNumber: {
    position: 'absolute',
    top: '0.25rem',
    left: '0.25rem',
    color: 'rgba(34, 34, 34, 0.1)',
    fontSize: '0.625rem',
    lineHeight: 1.1,
    zIndex: 10,
  },
  small: {
    fontSize: '0.25rem',
  },
  backdropRoot: {
    backgroundColor: palette.grey['600'],
  },
  dialogPaper: {
    zIndex: 1,
    maxWidth: '100%',
    borderRadius: 12,
    padding: '32px 0',
    margin: 0,
    boxShadow: `0 4px 8px ${palette.grey['300']}`,
    [breakpoints.up('md')]: {
      paddingTop: 64,
      paddingBottom: 64,
    },
  },
  dialogPaperWithoutTitle: {
    paddingTop: 48,
    [breakpoints.up('md')]: {
      paddingTop: 64,
    },
  },
  dialogPaperResponsiveWidthDefault: {
    width: '90vw',
    maxWidth: 320,
    [breakpoints.up('md')]: {
      width: 542,
      maxWidth: 'unset',
    },
  },
  dialogPaperResponsiveWidthXs: {
    width: '90vw',
    maxWidth: 320,
    [breakpoints.up('md')]: {
      width: 393,
      maxWidth: 'unset',
    },
  },
  dialogPaperResponsiveWidthSm: {
    width: '90vw',
    maxWidth: 320,
    [breakpoints.up('md')]: {
      width: 422,
      maxWidth: 'unset',
    },
  },
  dialogPaperResponsiveWidthMd: {
    width: '90vw',
    maxWidth: 320,
    [breakpoints.up('md')]: {
      width: 440,
      maxWidth: 'unset',
    },
  },
  dialogPaperResponsiveWidthMdwide: {
    width: '90vw',
    maxWidth: 320,
    [breakpoints.up('md')]: {
      width: 488,
      maxWidth: 'unset',
    },
  },
  dialogPaperResponsiveWidthMdwider: {
    width: '90vw',
    maxWidth: 310,
    [breakpoints.up('md')]: {
      width: 520,
      maxWidth: 'unset',
    },
  },
  dialogPaperResponsiveWidthXsfull: {
    width: '100%',
    maxWidth: 'unset',
    [breakpoints.up('sm')]: {
      width: 542,
    },
  },
  dialogPaperResponsiveWidthMdfixed: {
    width: 300,
    [breakpoints.up('md')]: {
      width: 440,
      maxWidth: 'unset',
    },
  },
  dialogPaperResponsiveWidthLg: {
    width: '95vw',
    [breakpoints.up('md')]: {
      width: 703,
    },
  },
  dialogPaperResponsiveWidthLgwide: {
    width: '90vw',
    [breakpoints.up('lg')]: {
      width: 776,
    },
  },
  dialogPaperResponsiveWidthXl: {
    width: '90vw',
    [breakpoints.up('sm')]: {
      width: 388,
    },
    [breakpoints.up('lg')]: {
      width: 946,
    },
  },
  dialogPaperResponsiveWidthXlwide: {
    width: '90vw',
    [breakpoints.up('sm')]: {
      width: 388,
    },
    [breakpoints.up('md')]: {
      width: 703,
    },
    [breakpoints.up('lg')]: {
      width: 946,
    },
  },
  dialogContentRoot: {
    padding: 0,
  },
  closeIconButton: {
    position: 'absolute',
    top: '0.625rem',
    right: '0.625rem',
    zIndex: 10,
    [breakpoints.up('md')]: {
      top: '1.25rem',
      right: '1.25rem',
    },
  },
  closeLight: {
    '& svg path': {
      fill: palette.common.white,
    },
  },
  header: {
    marginBottom: 16,
    padding: '0 24px',
    [breakpoints.up('md')]: {
      paddingLeft: 48,
      paddingRight: 48,
    },
  },
  content: {
    padding: '0 24px',
    [breakpoints.up('md')]: {
      paddingLeft: 48,
      paddingRight: 48,
    },
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.4,
    margin: 0,
    [breakpoints.up('md')]: {
      fontSize: fontSizes.xxl,
      lineHeight: 1.35,
    },
  },
  footer: {
    padding: '16px 24px 0',
    [breakpoints.up('md')]: {
      paddingLeft: 48,
      paddingRight: 48,
    },
  },
}));
